import { Palette } from 'lucide-react'

export default {
	icon:  Palette,
	name: 'Creator Dashboard',
	onClick: ({ router, onClose }: any) => {
		router.push('/creator-dashboard')
		onClose()
	},
	featured: false,
	filter: ({ loggedIn: _loggedIn }: any) => {
		return true
	}
}
